// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"ef29ab29","145":"6a20efff","355":"a2b0619b","825":"f0909883","876":"90f9511a","895":"3309cfcc"}[chunkId] + ".css";
};